module.exports = __webpack_public_path__ + "img/icon-word.ce655f60.png";